<template>
  <form-section :title="title" class="device-information-card">
    <el-col v-for="(item, index) in items" :key="index" :span="12">
      <form-item :label="item.label">
        <div class="item-box">
          <i v-if="item.icon" :class="item.icon"></i>
          <flag v-if="item.flag" class="flag" :iso="item.flag" />
          <overflow-tooltip :value="item.value" />
        </div>
      </form-item>
    </el-col>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'

export default {
  name: 'DeviceInformationCard',

  components: {
    OverflowTooltip,
    FormItem,
    FormSection
  },

  props: {
    title: {
      type: String,
      required: true
    },

    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.device-information-card {
  width: 100%;
  height: 100%;
}

>>> .content {
  background-color: #f8fafc;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}

.device-info-value-container i {
  align-self: center;
}

.item-box {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

.el-icon-empty-icon {
  margin-left: 3px;
  margin-right: 8px;
  background: #e6e6e6;
  border-radius: 8px;
  width: 16px;
  height: 16px;
}

.el-icon-empty-icon .empty-icon {
  background: none;
}

.el-icon-success {
  margin-left: 3px;
  margin-right: 8px;
  background: #1fca10;
  border-radius: 8px;
  width: 16px;
  height: 16px;
  color: transparent;
}

.flag {
  font-size: 14px;
  margin-right: 8px;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/modules/devices/components/DeviceInformationCard.vue